export enum EServiceTypeStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}
